interface IUserIdentity{
    id: number,
    email: string
}

export const instanceOfIUserIdentity = (object: any) : object is IUserIdentity => {
    return 'id' in object &&
            'email' in object
}

export default IUserIdentity